import {StatusPill} from "@/components/statusPill/StatusPill.tsx";
import {PillStatus} from "@/components/statusPill/StatusPill.types.ts";
import {MaintenanceEventType} from "@/lib/types/maintenance.ts";

const EventTypePillStatusMap: Record<MaintenanceEventType, PillStatus> = {
  [MaintenanceEventType.ENTERED]: PillStatus.MAINTENANCE_EVENT_ENTERED,
  [MaintenanceEventType.EXITED]: PillStatus.MAINTENANCE_EVENT_EXITED,
  [MaintenanceEventType.CHECK_PAUSED]: PillStatus.MAINTENANCE_EVENT_CHECK_PAUSED,
  [MaintenanceEventType.CHECK_RESUMED]: PillStatus.MAINTENANCE_EVENT_CHECK_RESUMED,
  [MaintenanceEventType.SCHEDULE_CREATED]: PillStatus.MAINTENANCE_EVENT_SCHEDULE_CREATED,
  [MaintenanceEventType.SCHEDULE_UPDATED]: PillStatus.MAINTENANCE_EVENT_SCHEDULE_UPDATED,
  [MaintenanceEventType.SCHEDULE_DELETED]: PillStatus.MAINTENANCE_EVENT_SCHEDULE_DELETED,
  [MaintenanceEventType.SCHEDULE_PAUSED]: PillStatus.MAINTENANCE_EVENT_SCHEDULE_PAUSED,
  [MaintenanceEventType.SCHEDULE_RESUMED]: PillStatus.MAINTENANCE_EVENT_SCHEDULE_RESUMED,
  [MaintenanceEventType.EXCEPTION_ADDED]: PillStatus.MAINTENANCE_EVENT_EXCEPTION_ADDED,
  [MaintenanceEventType.OCCURRENCE_STARTED]: PillStatus.MAINTENANCE_EVENT_OCCURRENCE_STARTED,
  [MaintenanceEventType.OCCURRENCE_COMPLETED]: PillStatus.MAINTENANCE_EVENT_OCCURRENCE_COMPLETED,
  [MaintenanceEventType.OCCURRENCE_CANCELED]: PillStatus.MAINTENANCE_EVENT_OCCURRENCE_CANCELED,
  [MaintenanceEventType.OCCURRENCE_REPLACED]: PillStatus.MAINTENANCE_EVENT_OCCURRENCE_REPLACED,
  [MaintenanceEventType.NOTIFICATION_CREATED]: PillStatus.MAINTENANCE_EVENT_NOTIFICATION_CREATED,
  [MaintenanceEventType.NOTIFICATION_UPDATED]: PillStatus.MAINTENANCE_EVENT_NOTIFICATION_UPDATED,
  [MaintenanceEventType.NOTIFICATION_DELETED]: PillStatus.MAINTENANCE_EVENT_NOTIFICATION_DELETED,
  [MaintenanceEventType.NOTIFICATION_SENT]: PillStatus.MAINTENANCE_EVENT_NOTIFICATION_SENT,
};

const EventTypeDisplayMap: Record<MaintenanceEventType, string> = {
  [MaintenanceEventType.ENTERED]: "Maintenance Started",
  [MaintenanceEventType.EXITED]: "Maintenance Ended",
  [MaintenanceEventType.CHECK_PAUSED]: "Checks Paused",
  [MaintenanceEventType.CHECK_RESUMED]: "Checks Resumed",
  [MaintenanceEventType.SCHEDULE_CREATED]: "Scheduled",
  [MaintenanceEventType.SCHEDULE_UPDATED]: "Schedule Updated",
  [MaintenanceEventType.SCHEDULE_DELETED]: "Schedule Deleted",
  [MaintenanceEventType.SCHEDULE_PAUSED]: "Schedule Paused",
  [MaintenanceEventType.SCHEDULE_RESUMED]: "Schedule Resumed",
  [MaintenanceEventType.EXCEPTION_ADDED]: "Exception Added",
  [MaintenanceEventType.OCCURRENCE_STARTED]: "Occurrence Started",
  [MaintenanceEventType.OCCURRENCE_COMPLETED]: "Occurrence Completed",
  [MaintenanceEventType.OCCURRENCE_CANCELED]: "Occurrence Canceled",
  [MaintenanceEventType.OCCURRENCE_REPLACED]: "Occurrence Replaced",
  [MaintenanceEventType.NOTIFICATION_CREATED]: "Notification Created",
  [MaintenanceEventType.NOTIFICATION_UPDATED]: "Notification Updated",
  [MaintenanceEventType.NOTIFICATION_DELETED]: "Notification Deleted",
  [MaintenanceEventType.NOTIFICATION_SENT]: "Notification Sent",
};

interface MaintenanceEventTypePillProps {
  eventType: MaintenanceEventType;
}

export const MaintenanceEventTypePill = ({eventType}: MaintenanceEventTypePillProps) => {
  const pillStatus = EventTypePillStatusMap[eventType] ?? PillStatus.UNKNOWN;

  return <StatusPill type="checks" variant="textAndIcon" status={pillStatus} />;
};

export const getEventTypeDisplay = (eventType: MaintenanceEventType): string => {
  return EventTypeDisplayMap[eventType] ?? eventType;
};
